import { isMultiKind } from '../guards/isMultiKind';
import { isSingleKind } from '../guards/isSingleKind';
import type { LDContext } from '../types/types';

/**
 * Format a context for UI display.
 * For single-kind or instance contexts, returns as-is.
 * For multi-kind contexts with a specified kind, windows to that kind.
 *
 * @param context - The context to format.
 * @param contextKind - Optional kind to window into for multi-kind contexts.
 * @param isContextInstance - Whether this is a context instance.
 * @returns The formatted context.
 */
export function formatContextForDisplay(
  context: LDContext,
  contextKind?: string,
  isContextInstance = false,
): LDContext {
  if (isContextInstance || isSingleKind(context)) {
    return context;
  }

  // For multi-kind contexts, window to the specified kind if provided
  if (isMultiKind(context) && contextKind) {
    return { [contextKind]: context[contextKind] };
  }

  return context;
}
